import { render, staticRenderFns } from "./SpinnerBorder.vue?vue&type=template&id=43ab3954"
import script from "./SpinnerBorder.vue?vue&type=script&lang=js"
export * from "./SpinnerBorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports